import type { ComponentOptions } from "vue";
import Vue, { getCurrentInstance } from "vue";
import type { NavigationGuard } from "vue-router";

/**
 * Router hooks inside the setup method are only supported in Vue 3. They can be
 * used outside of the setup method (using the Options API approach), and we can
 * access data returned from the setup method. However, if a render function is
 * returned from the setup method, we have no access to data defined inside and
 * therefore can't check dirty state etc.
 *
 * This is a hacky approach that allows us to use router hooks from inside the
 * setup method.
 *
 * TODO: Remove when we migrate to Vue 3.
 */

function onHook(
  name: keyof ComponentOptions<Vue>,
  callback: (...args: any) => void,
  vueInstance?: Vue | null
) {
  const vm = vueInstance ?? getCurrentInstance()?.proxy;

  const merge = Vue.config.optionMergeStrategies[name];

  if (vm && merge) {
    const prototype = Object.getPrototypeOf(vm.$options);
    // unregister hook if it already exists
    if (prototype[name]) {
      delete prototype[name];
    }
    prototype[name] = merge(vm.$options[name], callback);
  }
}

export function onBeforeRouteLeave(
  callback: NavigationGuard<Vue>,
  vueInstance?: Vue | null
) {
  return onHook("beforeRouteLeave", callback, vueInstance);
}
